import { SystemConfigValue } from "src/app/admin/system-configuration/shared/models/system-config-value";

/**
 * Casts the configuration value to its appropriate data type based on the dataType field.
 * @param systemConfigValue The SystemConfigValue object containing value and data type.
 * @returns The value casted to its proper type, or null if the input is undefined.
 * FIXME check if this needs to return default value in requesting places or null is fine
 */
export function readCastedValue(systemConfigValue?: SystemConfigValue): string | number | boolean | null {
    if (systemConfigValue) {
        switch (systemConfigValue.dataType) {
            case 'int':
                return parseInt(systemConfigValue.value);
            case 'bool':
                return (systemConfigValue.value === '1');
            default:
                return systemConfigValue.value;
        }
    }
    return null;
}